/** Mapas de apresentação (enum → UI) para o componente de viagens. */
import type { GenUiKey } from '../ui/i18n.js';

type Translate = (key: GenUiKey) => string;

/** Só apresentação (glifo/tom). O TEXTO do modal sai de `modalLabel`, pela
 *  tabela de i18n — daí não haver `label` aqui. */
export const MODAL_UI: Record<string, { icon: string; tone: string }> = {
  FLIGHT: { icon: 'airplane-takeoff', tone: 'brand' },
  HOTEL: { icon: 'bed', tone: 'ai' },
  BUS: { icon: 'bus', tone: 'green' },
  RENTAL: { icon: 'car', tone: 'amber' },
  MOBILITY: { icon: 'car-profile', tone: 'gray' },
};

const MODAL_LABEL_KEYS: Record<string, GenUiKey> = {
  FLIGHT: 'trip.modal.FLIGHT',
  HOTEL: 'trip.modal.HOTEL',
  BUS: 'trip.modal.BUS',
  RENTAL: 'trip.modal.RENTAL',
  MOBILITY: 'trip.modal.MOBILITY',
};

/** Variante tonal do badge; o texto vem de `tripStatusLabel`. */
export const TRIP_STATUS_UI: Record<string, { variant: string }> = {
  UPCOMING: { variant: 'upcoming' },
  ONGOING: { variant: 'confirmed' },
  COMPLETED: { variant: 'gray' },
  CANCELLED: { variant: 'cancelled' },
};

const TRIP_STATUS_KEYS: Record<string, GenUiKey> = {
  UPCOMING: 'trip.status.UPCOMING',
  ONGOING: 'trip.status.ONGOING',
  COMPLETED: 'trip.status.COMPLETED',
  CANCELLED: 'trip.status.CANCELLED',
};

/** Variante tonal do badge; o texto vem de `voucherStatusLabel`. */
export const VOUCHER_STATUS_UI: Record<string, { variant: string }> = {
  IN_PROGRESS: { variant: 'progress' },
  AWAITING_APPROVAL: { variant: 'amber' },
  CONFIRMED: { variant: 'confirmed' },
  CANCELLED: { variant: 'cancelled' },
  EXPIRED: { variant: 'gray' },
  DECLINED: { variant: 'cancelled' },
};

const VOUCHER_STATUS_KEYS: Record<string, GenUiKey> = {
  IN_PROGRESS: 'voucher.status.IN_PROGRESS',
  AWAITING_APPROVAL: 'voucher.status.AWAITING_APPROVAL',
  CONFIRMED: 'voucher.status.CONFIRMED',
  CANCELLED: 'voucher.status.CANCELLED',
  EXPIRED: 'voucher.status.EXPIRED',
  DECLINED: 'voucher.status.DECLINED',
};

export function modalLabel(kind: string | null | undefined, t: Translate): string | undefined {
  if (kind == null) return undefined;
  const key = MODAL_LABEL_KEYS[kind];
  return key ? t(key) : undefined;
}

export function tripStatusLabel(status: string | null | undefined, t: Translate): string {
  const key = status == null ? undefined : TRIP_STATUS_KEYS[status];
  return key ? t(key) : t('trip.status.UPCOMING');
}

export function voucherStatusLabel(
  status: string | null | undefined,
  t: Translate,
): string | undefined {
  const key = status == null ? undefined : VOUCHER_STATUS_KEYS[status];
  return key ? t(key) : undefined;
}
